import './index.scss';
import { useCallback, useContext, useEffect, useState } from 'react';
import { AiFillMessage, AiFillDelete, AiFillEdit } from 'react-icons/ai';
import { BsPrinterFill } from 'react-icons/bs'
import { IViewResltsProps } from '../types';
import { Header } from 'src/component/Layout';
import { Select } from 'src/component/Select';
import { Users } from 'src/assets/icon';
import { AppLabel, AppSpan, AppText, FlexColumn, FlexRow, RoundImageContainer } from 'src/style';
import ImageFallback from "src/assets/img/image-fallback.png";
import helpers, {
    getClassList,
    getStudentsList,
    getAcademicSessions,
    getAllStudentsInClass,
} from 'src/utils/helpers';
import AppInfoContext from 'src/provider/state-manager/appInfoProvider';
import { terms } from 'src/provider/config/constant';
import VisibilityContext from 'src/provider/state-manager/visibilityProvider';
import ApiContext from 'src/provider/API/call-service';
import { MemberTypeEnum } from 'src/model';
import { DeleteResultModal, ResultTable } from 'src/component/ViewResults';
import { CommentModal } from '../CommentModal';
import { EditResult } from '../EditResult';
import Logo from "src/assets/img/main-logo.jpg";

export const ViewStudentResult = ({ user }: IViewResltsProps) => {
    const { API } = useContext(ApiContext);
    const { info } = useContext(AppInfoContext);
    const { notifier, setModal } = useContext(VisibilityContext);
    const [data, setData] = useState({ studentClass: "", studentName: "", session: "", term: "" });
    const [editResult, setEditResult] = useState(false);

    const classList = getClassList(info);
    const sessions = getAcademicSessions();
    const allStudents = getStudentsList(info);
    const studentList = getAllStudentsInClass(allStudents, data.studentClass);

    const handleSubmit = useCallback(async () => {
        const validation = helpers.inputValidator(data);
        if (!validation.isValidated) return notifier.show(validation.message, 'Validation Response');
        await API.getResult(data);
    }, [data]);

    useEffect(() => {
        if (data.term) handleSubmit();
    }, [data]);

    useEffect(() => {
        if (user?.profile.memberType === MemberTypeEnum.STUDENT) {
            setData({
                ...data,
                studentClass: user?.profile?.memberClass,
                studentName: user?.profile?.username
            })
        }
    }, [user]);

    const handleSelect = useCallback((key: string, value: string) => {
        setData({ ...data, [key]: value });
    }, [data])

    console.log('sss', info)

    return !editResult ? (
        <div className='admin-view-results'>
            <FlexColumn className='view-results-logo' bottomMargin="3">
                <div className="logo-container">
                    <img src={Logo} alt="logo" className="menu-logo" />
                </div>
            </FlexColumn>

            <AppText className='show-on-print' textSize='2.1' fontWeight='500' align='center' color='#712126'>Virtuous Sprouts Academy</AppText>

            <Header user={user}>
                <FlexRow gap='2' className='grid'>
                    {user?.profile.memberType !== MemberTypeEnum.STUDENT ?
                        (<Select
                            className='select'
                            label='Class'
                            list={classList}
                            name='studentClass'
                            labelColor='#FFF5E5'
                            handleSelect={handleSelect}
                            placeholder='Select Class'
                        />) : null
                    }
                    {data.studentClass && user?.profile.memberType !== MemberTypeEnum.STUDENT ? (
                        <Select
                            className='select'
                            label='Student'
                            Icon={<Users />}
                            name='studentName'
                            list={studentList}
                            labelColor='#FFF5E5'
                            handleSelect={handleSelect}
                            placeholder='Select Student'
                        />
                    ) : null}
                    {data.studentName ? (
                        <Select
                            className='select'
                            label='Session'
                            list={sessions}
                            name='session'
                            labelColor='#FFF5E5'
                            handleSelect={handleSelect}
                            placeholder='Select Session'
                        />
                    ) : null}
                    {data.session ? (
                        <Select
                            className='select'
                            label='Term'
                            name='term'
                            list={terms}
                            labelColor='#FFF5E5'
                            placeholder='Select Term'
                            handleSelect={handleSelect}
                        />
                    ) : null}
                </FlexRow>
            </Header>
            {info?.result?.result ?
                (<div className="result-details">
                    <FlexRow
                        className='header-flex'
                        justifyContent='space-between'
                    >
                        <FlexRow className='header-left-content' alignItems='top' justifyContent='flex-start' gap='5'>
                            <FlexRow justifyContent='flex-start' alignItems='flex-start' gap='2'>
                                <RoundImageContainer className='img-container' size='5' isMaxWidth>
                                    <img src={info?.result?.studentProfile?.avater || ImageFallback} alt='user avatar' />
                                </RoundImageContainer>

                                <FlexColumn className='Print-details-gap' width='50' sizeUnit='%' alignItems='flex-start'>
                                    <AppText fontWeight='600' color='#712126'>
                                        {info?.result?.studentProfile?.firstName || 'STU003'}
                                        <AppSpan className='show-on-print' leftMargin='.5' fontWeight='600' color='#712126'>{info?.result?.studentProfile?.surname || 'STU003'}</AppSpan>
                                    </AppText>

                                    <AppText textSize='1.4' fontWeight='400' color='#374957'>
                                        ID: <AppSpan textSize='1.4' color='#374957' fontWeight='600'>
                                            {info?.result?.studentProfile?.regId || 'STU003'}
                                        </AppSpan>
                                    </AppText>

                                    {/* Student data for printing view */}
                                    <AppText className='show-on-print' textSize='1.4' fontWeight='400' color='#374957'>
                                        Class: <AppSpan textSize='1.4' color='#374957' fontWeight='600'>
                                            {info?.result?.studentProfile?.memberClass || 'STU003'}
                                        </AppSpan>
                                    </AppText>

                                    <AppText className='show-on-print' textSize='1.4' fontWeight='400' color='#374957'>
                                        Session: <AppSpan textSize='1.4' color='#374957' fontWeight='600'>
                                            {info?.result?.session || 'STU003'}
                                        </AppSpan>
                                    </AppText>

                                    <AppText className='show-on-print' textSize='1.4' fontWeight='400' color='#374957'>
                                        Term: <AppSpan textSize='1.4' color='#374957' fontWeight='600'>
                                            {info?.result?.term || 'STU003'}
                                        </AppSpan>
                                    </AppText>
                                </FlexColumn>
                            </FlexRow>

                            <AppText className='center-title' color='#374957' textSize='1.4'>
                                Student Results
                            </AppText>
                        </FlexRow>
                        {user?.profile.memberType === MemberTypeEnum.ADMIN ?
                            (<FlexRow className='group-icons hide-on-print' gap='1' justifyContent='flex-end'>
                                <div
                                    onClick={() => window?.print()}
                                    className='icon-container'
                                    title='Print'>
                                    <BsPrinterFill size={20} />
                                </div>

                                <div
                                    onClick={() => setModal({ key: 'showCommentModal', value: true })}
                                    className='icon-container'
                                    title='Add comment'>
                                    <AiFillMessage size={20} />
                                </div>

                                <div onClick={() => setEditResult(true)} className="icon-container" title='Edit result'>
                                    <AiFillEdit size={20} />
                                </div>

                                <div
                                    title='Delete result'
                                    className="icon-container"
                                    onClick={() => setModal({ key: 'deleteResultModal', value: true })}
                                >
                                    <AiFillDelete size={20} />
                                </div>
                            </FlexRow>) : user?.profile.memberType === MemberTypeEnum.STUDENT ? (
                                <FlexRow className='group-icons hide-on-print' gap='1' justifyContent='flex-end'>
                                    <div
                                        onClick={() => window?.print()}
                                        className='icon-container'
                                        title='Print'>
                                        <BsPrinterFill size={20} />
                                    </div>
                                </FlexRow>
                            ) : null
                        }
                    </FlexRow>

                    <ResultTable />

                    <div className="comment">
                        {info?.result?.teacherComment ?
                            (<FlexRow gap='1' alignItems='flex-start' justifyContent='flex-start'>
                                <AppLabel fontWeight='600' color='#A77B37' bottomMargin='0'>Teacher's Comment:</AppLabel>
                                <AppText fontWeight='500' color='#374957'>{info?.result?.teacherComment}</AppText>
                            </FlexRow>) : null
                        }
                        {info?.result?.adminComment ?
                            (<FlexRow gap='1' alignItems='center' justifyContent='flex-start'>
                                <AppLabel fontWeight='600' color='#A77B37' bottomMargin='0'>Principal's Comment:</AppLabel>
                                <AppText fontWeight='500' color='#374957'>{info?.result?.adminComment}</AppText>
                            </FlexRow>) : null
                        }
                    </div>
                </div>) : null
            }
            <CommentModal />
            <DeleteResultModal />
        </div>
    ) : <EditResult setEditResult={setEditResult} />
}
